// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-salary-package.page.title': 'Salary Packages',
    'team-member-salary-package.page.archive.title': 'Archived Salary Packages',
    'team-member-salary-package.page.search_results': 'Search Results',
    'team-member-salary-package.page.create.title': 'Create New Salary Package',
    'team-member-salary-package.page.search.title': 'Find Salary Packages',
    'team-member-salary-package.page.edit.title': 'Edit Salary Package',
    'team-member-salary-package.page.view.title': 'View Salary Package',
    'team-member-salary-package.page.all': 'All',

    'team-member-salary-package.button.cancel': 'Cancel',
    'team-member-salary-package.button.select': 'Select',
    'team-member-salary-package.button.find': 'Find Packages',
    'team-member-salary-package.button.search': 'Apply',
    'team-member-salary-package.button.create': 'Save Package',
    'team-member-salary-package.button.new': 'New Package',
    'team-member-salary-package.button.save': 'Save Changes',
    'team-member-salary-package.button.archive': 'Archive',
    'team-member-salary-package.button.delete': 'Permanently Delete',
    'team-member-salary-package.button.edit': 'Edit',
    'team-member-salary-package.button.restore': 'Restore',
    'team-member-salary-package.button.reset': 'Reset',

    'team-member-salary-package.placeholder.search': 'Search team member salary packages',

    'team-member-salary-package.link.create_first_team_member_salary_package': 'Click here to create your first team member salary package',
    'team-member-salary-package.link.team_member_salary_packages': ' Return to Salary Packages',
    'team-member-salary-package.link.archive': 'Archived Salary Packages',
    'team-member-salary-package.link.retry': 'Click here to retry',

    'team-member-salary-package.checkbox.all': 'Check All',
    'team-member-salary-package.checkbox.actions_label': 'with selected',

    'team-member-salary-package.label.team_member_name': 'Team Member',

    'team-member-salary-package.label.from__from_date': 'From from date',
    'team-member-salary-package.label.to__from_date': 'To from date',
    'team-member-salary-package.label.from_date': 'From Date',

    'team-member-salary-package.label.from__thru_date': 'From thru date',
    'team-member-salary-package.label.to__thru_date': 'To thru date',
    'team-member-salary-package.label.thru_date': 'Thru Date',

    'team-member-salary-package.label.payroll_remuneration_type_name': 'Payroll Remuneration Type',
    'team-member-salary-package.label.payslip_label': 'Payslip Label',
    'team-member-salary-package.label.is_taxable': 'Is Taxable',
    'team-member-salary-package.label.memo': 'Memo',
    'team-member-salary-package.label.currency_name': 'Currency',

    'team-member-salary-package.label.from__currency_amount_in_cents': 'From Amount',
    'team-member-salary-package.label.to__currency_amount_in_cents': 'To Amount',
    'team-member-salary-package.label.currency_amount_in_cents': 'Amount',

    'team-member-salary-package.label.from__base_amount_in_cents': 'From base amount in cents',
    'team-member-salary-package.label.to__base_amount_in_cents': 'To base amount in cents',
    'team-member-salary-package.label.base_amount_in_cents': 'Base Amount In Cents',

    'team-member-salary-package.label.from__system_amount_in_cents': 'From system amount in cents',
    'team-member-salary-package.label.to__system_amount_in_cents': 'To system amount in cents',
    'team-member-salary-package.label.system_amount_in_cents': 'System Amount In Cents',

    'team-member-salary-package.label.from__created_at': 'From created at',
    'team-member-salary-package.label.to__created_at': 'To created at',
    'team-member-salary-package.label.created_at': 'Created At',

    'team-member-salary-package.label.from__updated_at': 'From updated at',
    'team-member-salary-package.label.to__updated_at': 'To updated at',
    'team-member-salary-package.label.updated_at': 'Updated At',

    'team-member-salary-package.label.from__deleted_at': 'From deleted at',
    'team-member-salary-package.label.to__deleted_at': 'To deleted at',
    'team-member-salary-package.label.deleted_at': 'Deleted At',

    'team-member-salary-package.label.status': 'Status',

    'team-member-salary-package.sort.field_label': 'Field',
    'team-member-salary-package.sort.direction_label': 'Direction',
    'team-member-salary-package.sort.direction_ascending': 'Ascending',
    'team-member-salary-package.sort.direction_descending': 'Descending',

    'team-member-salary-package.modal.title.team_member_salary_package_archive': 'Archive Salary Package',
    'team-member-salary-package.modal.title.team_member_salary_package_delete_permanently': 'Delete Salary Package',
    'team-member-salary-package.modal.title.team_member_salary_package_restore': 'Restore Salary Package',

    'team-member-salary-package.modal.message.team_member_salary_package_archive':
        'Are you sure that you want to move this team member salary package to the archive? | Are you sure that you want to move these team member salary packages to the archive?',
    'team-member-salary-package.modal.message.team_member_salary_package_delete_permanently':
        'Are you sure that you want to permanently delete this team member salary package? This action cannot be undone. | Are you sure that you want to permanently delete these team member salary packages? This action cannot be undone.',
    'team-member-salary-package.modal.message.team_member_salary_package_restore': 'Are you sure that you want to restore this team member salary package? | Are you sure that you want to restore these team member salary packages?',

    'team-member-salary-package.success.message.team_member_salary_package_created': 'Your team member salary package has been created',
    'team-member-salary-package.success.message.team_member_salary_package_updated': 'Your team member salary package has been updated',
    'team-member-salary-package.success.message.team_member_salary_package_restored': 'Your team member salary package has been restored | All selected team member salary packages were restored',
    'team-member-salary-package.success.message.team_member_salary_package_deleted': 'Your team member salary package has been permanently deleted | All selected team member salary packages were permanently deleted',
    'team-member-salary-package.success.message.archived_team_member_salary_packages': 'Your team member salary package was moved to the archive | All selected team member salary packages were moved to the archive',

    'team-member-salary-package.error.message.archived_team_member_salary_packages': 'This team member salary package was already moved to the archive | These team member salary packages were already moved to the archive',
    'team-member-salary-package.error.message.team_member_salary_package_deleted': 'This team member salary package was already permanently deleted | These team member salary packages were already permanently deleted',
    'team-member-salary-package.error.message.team_member_salary_package_restored': 'This team member salary package was already restored | These team member salary packages were already restored',
    'team-member-salary-package.error.message.error_loading_page': 'Sorry, there was an error loading team member salary package.| Sorry, there was an error loading team member salary packages.',

    'team-member-salary-package.message.search.no_archived_team_member_salary_packages': "You haven't archived any team any member any salary any packages as yet.",
};
